/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MagentoFieldMappingDTO { 
    internalFieldCode: string;
    magentoAttributeCode: string;
    syncDirection: MagentoFieldMappingDTO.SyncDirectionEnum;
    dataType: MagentoFieldMappingDTO.DataTypeEnum;
}
export namespace MagentoFieldMappingDTO {
    export const SyncDirectionEnum = {
        Inbound: 'INBOUND',
        Outbound: 'OUTBOUND',
        Bidirectional: 'BIDIRECTIONAL'
    } as const;
    export type SyncDirectionEnum = typeof SyncDirectionEnum[keyof typeof SyncDirectionEnum];
    export const DataTypeEnum = {
        String: 'STRING',
        Decimal: 'DECIMAL',
        Boolean: 'BOOLEAN',
        Integer: 'INTEGER',
        Datetime: 'DATETIME'
    } as const;
    export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];
}


